import { StrictMode, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';

import { App } from '@/App';
import { AuthProvider } from '@/auth/AuthContext';
import { ThemeProvider } from '@/common/ThemeContext';
import { Configs } from '@/config';
import '@/index.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element #root not found');
}

function AppProviders({ children }: { children: ReactNode }) {
  const tree = (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>{children}</AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );

  if (Configs.googleSsoEnabled) {
    return <GoogleOAuthProvider clientId={Configs.googleClientId}>{tree}</GoogleOAuthProvider>;
  }

  return tree;
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </StrictMode>
);
